// The AutoClipper mobile app writes this flag before its WebView loads the
// site. Storage can be missing or throw; any failure means "not embedded".

export const EMBEDDED_APP_KEY = 'autoclipper:embedded-app';

export type EmbeddedApp = 'ios' | 'android';

export function readEmbeddedApp(storage: Pick<Storage, 'getItem'> | null | undefined): EmbeddedApp | null {
  try {
    const value = storage?.getItem(EMBEDDED_APP_KEY);
    return value === 'ios' || value === 'android' ? value : null;
  } catch {
    return null;
  }
}

/** Asks the app to open its native plans list. False outside the app's WebView. */
export function postOpenPlans(): boolean {
  const bridge = (window as { ReactNativeWebView?: { postMessage?: (message: string) => void } })
    .ReactNativeWebView;
  if (!bridge?.postMessage) return false;
  bridge.postMessage(JSON.stringify({ type: 'open-plans' }));
  return true;
}

/** The embed flag as of now, from this window's localStorage. */
export function currentEmbeddedApp(): EmbeddedApp | null {
  try {
    return readEmbeddedApp(typeof window === 'undefined' ? null : window.localStorage);
  } catch {
    return null;
  }
}
